__turbopack_context__.v({
  "cta": "HighlightedFeatures-module-scss-module__XqP37W__cta",
  "highlighted-feature-description": "HighlightedFeatures-module-scss-module__XqP37W__highlighted-feature-description",
  "highlighted-feature-headline": "HighlightedFeatures-module-scss-module__XqP37W__highlighted-feature-headline",
  "highlighted-feature-image": "HighlightedFeatures-module-scss-module__XqP37W__highlighted-feature-image",
  "highlighted-feature-wrapper": "HighlightedFeatures-module-scss-module__XqP37W__highlighted-feature-wrapper",
  "new-callout": "HighlightedFeatures-module-scss-module__XqP37W__new-callout",
  "new-callout-wrapper": "HighlightedFeatures-module-scss-module__XqP37W__new-callout-wrapper",
  "section-title-wrapper": "HighlightedFeatures-module-scss-module__XqP37W__section-title-wrapper",
});
